import { useEffect } from "react";

interface Props {
  to: string;
}

/**
 * Cross-domain redirect helper. React Router cannot navigate to an external
 * origin, so this component performs window.location.replace at mount time.
 * Used by the BRIDGE SERP split to send authority-side URLs to umojareg.org.
 */
export default function ExternalRedirect({ to }: Props) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return (
    <div style={{ padding: "2rem", textAlign: "center", fontFamily: "sans-serif" }}>
      Redirecting to{" "}
      <a href={to} style={{ color: "#0a66c2" }}>
        {to}
      </a>
      …
    </div>
  );
}
